export default __webpack_public_path__ + "static/media/thecrypt.310f5085.svg";